import { useLocalStorage } from '@rehooks/local-storage';
import { PropsWithChildren, useMemo } from 'react';

import { LOCAL_STORAGE_PREFIX, LocalStorageKeys } from '~/common/constants/localStorage.ts';
import { useConfig } from '~/components/ConfigProvider';

import { SearchContextProviderContext } from './SearchContextProvider.context.ts';

export const SearchContextProvider = ({ children }: PropsWithChildren) => {
  const { search } = useConfig();
  const [aiSearchIsEnabled, setAiSearchIsEnabled] = useLocalStorage(
    `${LOCAL_STORAGE_PREFIX}${LocalStorageKeys.SEARCH_AI_ENABLED}`,
    search.defaultSearchModeIsSemantic,
  );

  const value = useMemo(
    () => ({
      aiSearchIsEnabled,
      setAiSearchIsEnabled,
    }),
    [aiSearchIsEnabled, setAiSearchIsEnabled],
  );

  return <SearchContextProviderContext.Provider value={value}>{children}</SearchContextProviderContext.Provider>;
};
